export const TileMinZoom = 14;

export const SourceNDVIName = 'ndvi-source-';
export const LayerNDVIName = 'ndvi-layer-';
export const WmsImageName = 'wms-image-';
export const WmsLayerImageName = 'wms-image-layer';

export const FilterParameters = ['bbchAI', 'ndvi', 'temperature', 'gdd', 'humidity', 'dew'];